import { useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { getlisthash } from '../../../domain/api/EvbiApi';
import { USER_ID } from '../../../../app/api-client/constants';

/**
 * Custom hook para obtener la lista de estaciones EVBI del usuario autenticado
 * Consume el endpoint GET /v1/evbi/list/admin/hash/{hash}
 * 
 * @returns {Object} { estaciones, loading, error, refetch }
 * @returns {Array} return.estaciones - Lista de estaciones [{id, name}]
 * @returns {boolean} return.loading - Estado de carga
 * @returns {string|null} return.error - Mensaje de error si ocurre
 * @returns {Function} return.refetch - Función para recargar estaciones
 */
export const useEstaciones = () => {
    const dispatch = useDispatch();
    const [estaciones, setEstaciones] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchEstaciones = useCallback(async () => {
        const userId = localStorage.getItem(USER_ID);

        if (!userId) {
            setLoading(false);
            setError('No se encontró el usuario autenticado');
            return;
        }

        try {
            setLoading(true);
            setError(null);

            const response = await getlisthash(dispatch, userId, '', 0, 1000);

            if (response?.error) {
                setError('Error al obtener las estaciones');
                setEstaciones([]);
                return;
            }

            const stations = (response?.content || []).map((station) => ({
                id: station.id,
                name: station.name,
                modulos: station.modulos || [],
                imei: station.modulos?.[0]?.imei || null,
            }));

            setEstaciones(stations);
        } catch (err) {
            console.error('Error fetching estaciones:', err);
            setError('Error al obtener las estaciones');
            setEstaciones([]);
        } finally {
            setLoading(false);
        }
    }, [dispatch]);

    useEffect(() => {
        fetchEstaciones();
    }, [fetchEstaciones]);

    return { estaciones, loading, error, refetch: fetchEstaciones };
};

export default useEstaciones;
